// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"a807bd37","79":"ddf211b9","551":"3e560da9","945":"d477a5a4"}[chunkId] + ".js";
};